/* kl-search v1.2 (2026-10-28 广告AI) — 老板 1028「DC 的下拉搜索栏出现的结果,文字部分看不清,请紧急修复搜索框成基础设施」,在 v1.1 上补两层通用兜底(9 店同一份):
   ④ 带 * 的查询绝不显示给顾客:主题/搭建器晚于 DOMContentLoaded 才把网址里的 q 回填进搜索框(如 DC 的 Foxify 页头)也能清——载入后 0.5/1.5/3 秒与 load 各再清一次、
      聚焦搜索框时再清;搜索框里若已是「每词带 *」的旧值,联想请求照样按 AND 查询发,下拉里回显一律去掉 *;探测为空时回退的是去掉 * 的原词。
   ⑤ 联想下拉可读性兜底:下拉内容出现/更新时,逐个检查有文字的元素与它背后背景的对比度,低于 3:1 的才改成深色字(浅底)或浅色字(深底);
      按钮、促销价等本来清楚的不动;在 MutationObserver 回调里同步改(画面刷新前),顾客看不到闪一下;只在聚焦/输入搜索框后的 15 秒内监听。
   v1.1 (2026-09-10) — 站内搜索「所见即所得」层。老板:「搜名字下面不显示该产品…深度优化每一个网站的搜索」。
   根因:Shopify 原生搜索对多词查询是 OR + 模糊匹配,再按它自己的相关性排序;整名「Ridgeline Alabaster Linear Chandelier」
   会被一堆只命中 alabaster/chandelier 标签的商品挤掉。Shopify 支持前缀语法(term*)且每个词都带 * 时变成 AND。
   做法:① 拦截主题/自建搜索框对 /search/suggest(.json) 的请求,把 q 改写成「每词加 *」的 AND 查询;空结果自动回退原查询;
        ② 搜索表单提交前用 1 条 suggest 探测,同样 AND 优先、空则原样;③ 结果页把可见的 * 去掉。不改任何主题文件的搜索代码。 */
(function () {
  'use strict';
  if (window.__klSearch) return; window.__klSearch = { v: '1.2' };
  var STOP = /[*"':()\[\]{}]/;                                  // 用户自己用了语法就不动
  var ASCII = /^[\x20-\x7EÀ-ɏ]+$/;                              // 拉丁文字才改写(日/阿等分词不同,保持原样)
  var STARRED = /^\s*[^\s*"':()\[\]{}]+\*(\s+[^\s*"':()\[\]{}]+\*)*\s*$/;   // v1.2:每个词都以 * 结尾 = 本组件写出的 AND 查询
  var QSEL = 'input[name="q"], input[type="search"]';
  function unstar(q) { return String(q || '').replace(/\*/g, '').replace(/\s+/g, ' ').trim(); }
  function stem(t) {
    var w = t.replace(/[^\w\-]+$/, '');
    if (w.length > 3 && /s$/i.test(w) && !/ss$/i.test(w)) w = /(ches|shes|xes|zes)$/i.test(w) ? w.slice(0, -2) : w.slice(0, -1);
    return w;
  }
  function tier1(q) {
    q = (q || '').trim();
    if (!q || STOP.test(q) || !ASCII.test(q)) return null;
    var terms = q.split(/\s+/).filter(Boolean); if (!terms.length) return null;
    var out = terms.map(function (t) { var s = stem(t); return /[A-Za-z0-9À-ɏ]$/.test(s) ? s + '*' : t; }).join(' ');
    return out === q ? null : out;
  }
  function pair(q) {   // v1.2:{raw 给顾客看, star 发给 Shopify};旧的带 * 值也拆开
    q = String(q || '');
    if (STARRED.test(q)) { var r = unstar(q); return r ? { raw: r, star: q.trim().replace(/\s+/g, ' ') } : null; }
    var s = tier1(q); return s ? { raw: q, star: s } : null;
  }
  function isSuggest(u) { try { var p = new URL(u, location.origin); return p.origin === location.origin && /\/search\/suggest(\.json)?\/?$/.test(p.pathname) && p.searchParams.has('q'); } catch (e) { return false; } }
  function skuOnly(p) { var f = p.searchParams.get('resources[options][fields]') || ''; return f && !/title/.test(f); }
  function hasHits(text, json) {
    if (json) { try { var r = (JSON.parse(text).resources || {}).results || {}; return Object.keys(r).some(function (k) { return Array.isArray(r[k]) && r[k].length > 0; }); } catch (e) { return true; } }
    return /\/products\/|\/collections\/[a-z0-9-]+"|\/blogs\//.test(text);
  }
  function scrub(text, star, raw) {  // 只把响应里「可见文本」回显的带 * 查询换回用户输入;链接里的编码形式保留(结果页仍走 AND)
    if (!star || star === raw) return text;
    return text.split(star).join(raw);
  }
  /* ── fetch ── */
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (!url || !isSuggest(url)) return _fetch.apply(this, arguments);
      var u = new URL(url, location.origin), q0 = u.searchParams.get('q'), pr = pair(q0);
      if (!pr || skuOnly(u)) return _fetch.apply(this, arguments);
      var raw = pr.raw, star = pr.star, self = this, args = arguments, json = /\.json\/?$/.test(u.pathname);
      var plain = function () { if (q0 === raw) return _fetch.apply(self, args); var u2 = new URL(u.toString()); u2.searchParams.set('q', raw); return _fetch.call(self, u2.toString(), init); };
      var u1 = new URL(u.toString()); u1.searchParams.set('q', star);
      return _fetch.call(self, u1.toString(), init).then(function (res) {
        if (!res.ok) return plain();
        return res.clone().text().then(function (text) {
          if (!hasHits(text, json)) return plain();
          var h = new Headers(res.headers); h.delete('content-length');
          return new Response(scrub(text, star, raw), { status: res.status, statusText: res.statusText, headers: h });
        });
      }).catch(function () { return plain(); });
    };
  }
  /* ── XMLHttpRequest(老主题):只改写,不回退 ── */
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && isSuggest(url)) {
          var u = new URL(url, location.origin), pr = pair(u.searchParams.get('q'));
          if (pr && !skuOnly(u)) { u.searchParams.set('q', pr.star); arguments[1] = u.toString(); }
        }
      } catch (e) {}
      return _open.apply(this, arguments);
    };
  }
  /* ── 搜索表单提交:AND 优先,探测为空则原样(去掉 * 的原词) ── */
  var cfg = document.getElementById('kl-search-config'); var searchUrl = '/search';
  try { searchUrl = (JSON.parse(cfg.textContent).search_url || '/search').replace(/\/$/, ''); } catch (e) {}
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!(f instanceof HTMLFormElement)) return;
    var action = (f.getAttribute('action') || '').split('?')[0].replace(/\/$/, '');
    if (!/\/search$/.test(action)) return;
    var inp = f.querySelector('input[name="q"]'); if (!inp) return;
    var pr = pair(inp.value.trim()); if (!pr) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var raw = pr.raw, star = pr.star;
    var params = new URLSearchParams(new FormData(f)); params.set('q', star); if (!params.has('type')) params.set('type', 'product');
    var go = function (useStar) { params.set('q', useStar ? star : raw); location.assign(action + '?' + params.toString()); };
    var probe = action + '/suggest.json?' + new URLSearchParams({ q: star, 'resources[type]': 'product', 'resources[limit]': '1' }).toString();
    var done = false, t = setTimeout(function () { if (!done) { done = true; go(false); } }, 1500);
    _fetch(probe).then(function (r) { return r.json(); }).then(function (j) {
      if (done) return; done = true; clearTimeout(t);
      var ps = (((j || {}).resources || {}).results || {}).products || []; go(ps.length > 0);
    }).catch(function () { if (!done) { done = true; clearTimeout(t); go(false); } });
  }, true);
  /* ── 自建搜索框的「查看全部结果」/联想词链接:同样 AND 优先 ── */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null; if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
    var u; try { u = new URL(a.getAttribute('href'), location.origin); } catch (err) { return; }
    if (u.origin !== location.origin || !/\/search\/?$/.test(u.pathname) || !u.searchParams.has('q')) return;
    var pr = pair(u.searchParams.get('q')); if (!pr) return;
    e.preventDefault();
    var probe = u.pathname.replace(/\/$/, '') + '/suggest.json?' + new URLSearchParams({ q: pr.star, 'resources[type]': 'product', 'resources[limit]': '1' }).toString();
    var done = false, t = setTimeout(function () { if (!done) { done = true; u.searchParams.set('q', pr.raw); location.assign(u.toString()); } }, 1500);
    _fetch(probe).then(function (r) { return r.json(); }).then(function (j) {
      if (done) return; done = true; clearTimeout(t);
      var ps = (((j || {}).resources || {}).results || {}).products || []; u.searchParams.set('q', ps.length ? pr.star : pr.raw); location.assign(u.toString());
    }).catch(function () { if (!done) { done = true; clearTimeout(t); u.searchParams.set('q', pr.raw); location.assign(u.toString()); } });
  }, true);
  /* ── 结果页:原样查询先探测 AND 有结果就换成 AND;带 * 的把可见 * 去掉(v1.2:晚回填的搜索框也清) ── */
  function upgrade(q) {
    var star = tier1(q); if (!star) return;
    var u = new URL(location.href); var probe = u.pathname.replace(/\/$/, '') + '/suggest.json?' + new URLSearchParams({ q: star, 'resources[type]': 'product', 'resources[limit]': '1' }).toString();
    _fetch(probe).then(function (r) { return r.json(); }).then(function (j) {
      var ps = (((j || {}).resources || {}).results || {}).products || [];
      if (ps.length) { u.searchParams.set('q', star); location.replace(u.toString()); }
    }).catch(function () {});
  }
  function cleanInputs() {
    Array.prototype.forEach.call(document.querySelectorAll(QSEL), function (i) { if (i.value && STARRED.test(i.value)) i.value = unstar(i.value); });
  }
  function clean(full) {
    var q; try { q = new URL(location.href).searchParams.get('q'); } catch (e) { return; }
    if (!q || q.indexOf('*') < 0) return;
    var raw = unstar(q);
    Array.prototype.forEach.call(document.querySelectorAll(QSEL), function (i) { if (i.value === q || (i.value && STARRED.test(i.value) && unstar(i.value) === raw)) i.value = raw; });
    if (!full) return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.indexOf(q) > -1) list.push(n); }
    list.forEach(function (n) { n.nodeValue = n.nodeValue.split(q).join(raw); });
    try { if (document.title.indexOf(q) > -1) document.title = document.title.split(q).join(raw); } catch (e) {}
  }
  if (/\/search\/?$/.test(location.pathname)) {
    var q0 = null; try { q0 = new URL(location.href).searchParams.get('q'); } catch (e) {}
    if (q0 && q0.indexOf('*') < 0) upgrade(q0);
    else if (q0) {
      var run = function () { clean(true); [500, 1500, 3000].forEach(function (ms) { setTimeout(function () { clean(ms === 3000); }, ms); }); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
      window.addEventListener('load', function () { clean(true); });
    }
  }
  /* ── v1.2 联想下拉可读性兜底(各站通用) ── */
  var PANEL = '.predictive-search, predictive-search, [class*="predictive-search"], [id*="predictive-search"], [class*="search-suggest"], [class*="search-flydown"], [class*="search__results"], [class*="autocomplete"]';
  function lum(c) {
    var m = /rgba?\(([^)]+)\)/.exec(c || ''); if (!m) return null;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(Number); if (p.length > 3 && p[3] < 0.6) return null;
    var f = function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(p[0]) + 0.7152 * f(p[1]) + 0.0722 * f(p[2]);
  }
  function bgL(el) { for (var e = el; e && e.nodeType === 1; e = e.parentElement) { var l = lum(getComputedStyle(e).backgroundColor); if (l !== null) return l; } return 1; }
  function ownText(el) { for (var c = el.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && c.nodeValue.trim()) return true; return false; }
  function guard() {
    var ps = document.querySelectorAll(PANEL);
    for (var i = 0; i < ps.length; i++) {
      var els = ps[i].querySelectorAll('*');
      for (var j = 0, n = 0; j < els.length && n < 400; j++) {
        var el = els[j]; if (el.__klc || !ownText(el)) continue; n++;
        var tl = lum(getComputedStyle(el).color); if (tl === null) continue;
        var bl = bgL(el), r = (Math.max(bl, tl) + 0.05) / (Math.min(bl, tl) + 0.05);
        if (r < 3) { el.style.setProperty('color', bl > 0.35 ? '#1f1c18' : '#f7f4ee', 'important'); el.__klc = 1; }
      }
    }
  }
  var mo = null, moUntil = 0;
  function watch() {
    moUntil = Date.now() + 15000; guard();
    if (mo || !window.MutationObserver || !document.body) return;
    mo = new MutationObserver(function () { guard(); if (Date.now() > moUntil) { mo.disconnect(); mo = null; } });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('focusin', function (e) { var t = e.target; if (t && t.matches && t.matches(QSEL)) { if (t.value && STARRED.test(t.value)) t.value = unstar(t.value); watch(); } }, true);
  document.addEventListener('input', function (e) { var t = e.target; if (t && t.matches && t.matches(QSEL)) watch(); }, true);
  window.__klSearch.tier1 = tier1; window.__klSearch.pair = pair; window.__klSearch.guard = guard; window.__klSearch.clean = cleanInputs;
})();
